import {ClockHandsIcon} from '@github-ui/custom-icons/ClockHandsIcon'
import {
  getMergeQueueEntryDescription,
  MergeQueueEntry,
  useMergeQueueEntryDequeueAction,
} from '@github-ui/mergebox/components/sections/merge-queue/MergeQueueEntry'

import {ForYouItem} from '../shared/ForYouItem'
import type {ForYouItemProps} from '../shared/for-you-item.types'
import {useMergeabilityData} from '../mergeability/use-mergeability-data'
import {noop} from '@github-ui/noop'
import {Button, Link} from '@primer/react'

export function shouldShowQueuedPR(data: ReturnType<typeof useMergeabilityData>) {
  return data?.mergeQueueSection?.shouldRender ?? false
}

export function QueuedPR() {
  const data = useMergeabilityData()

  if (!data) return null

  const {mergeBoxPullRequest} = data

  return (
    <MergeQueueEntry
      mergeQueue={mergeBoxPullRequest.mergeQueue}
      mergeQueueEntry={mergeBoxPullRequest.mergeQueueEntry}
      viewerCanAddAndRemoveFromMergeQueue={mergeBoxPullRequest.viewerCanAddAndRemoveFromMergeQueue}
      onDequeueSuccess={noop} // TODO - figure out where focus should go after dequeue
      analyticsTargetPrefix="OVERVIEW"
    >
      <QueuedForYouItem
        subText={queueSubText(
          mergeBoxPullRequest.mergeQueueEntry?.position,
          mergeBoxPullRequest.mergeQueue?.url,
          mergeBoxPullRequest.mergeQueueEntry?.isLocked ?? false,
        )}
      />
    </MergeQueueEntry>
  )
}

function QueuedForYouItem({subText}: {subText: ForYouItemProps['subText']}) {
  const {canDequeue, openConfirmation} = useMergeQueueEntryDequeueAction()

  return (
    <ForYouItem
      itemId="queued-pr"
      visual={{kind: 'icon', icon: ClockHandsIcon, tone: 'attention', glyphSize: 24}}
      title="Queued to merge..."
      subText={subText}
      actions={
        canDequeue
          ? [
              {
                id: 'remove-from-queue',
                content: (
                  <Button size="small" variant="danger" onClick={openConfirmation}>
                    Remove from queue
                  </Button>
                ),
              },
            ]
          : undefined
      }
    />
  )
}

function queueSubText(
  position: number | null | undefined,
  queueUrl: string | null | undefined,
  entryIsLocked: boolean,
): ForYouItemProps['subText'] {
  const description = getMergeQueueEntryDescription(position, queueUrl, entryIsLocked)
  if (!description) return undefined

  return (
    <>
      {description.text}{' '}
      <Link inline className="Link--inTextBlock" href={description.queueUrl}>
        merge queue
      </Link>
      .
    </>
  )
}
